import React, { useContext } from 'react';
import BreakdownContext from '../BreakdownContext';
import { DATE_DIMENSION } from '../../../_config/constant';
import { DauBreakdownContextProps } from '../_type';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { FilterContextType } from '@/pages/dashboard/components/PageContainer/type';

const OsBreakDownContext = (props: DauBreakdownContextProps) => {
  const contextObj = useContext(FilterContext)
  const { filterVal, filterLoading } = contextObj || {};
  
  return (
    <>
      <BreakdownContext
        componetIndex={1}
        isPlatform={true}
        type={DATE_DIMENSION.DAY}
        filterVal={filterVal}
        filterLoading={filterLoading}
      />
    </>
  );
};

export default OsBreakDownContext;
